export const MANDATORY = 'mandatory';
export const POSSIBLE = 'possible';

const LABELS = {
	[MANDATORY]: 'Muss gegeben sein (verpflichtend)',
	[POSSIBLE]: 'Kann gegeben sein (wünschenswert)',
};

export function getLabel (id)
{
	return LABELS[id];
}

export function getOptions ()
{
	return [
		{id: MANDATORY, label: getLabel(MANDATORY)},
		{id: POSSIBLE, label: getLabel(POSSIBLE)},
	];
}
